import {Directive, ElementRef, Renderer} from '@angular/core';
import {Util} from "../app/util";

@Directive({
    selector: '[hide-header]',
    host: {
        "(ionScroll)": "onScroll($event)"
    }
})
export class HideHeaderDirective {

    private header: HTMLElement;
    private headerHeight: number;

    private scrollContent: HTMLElement;
    private scrollTop: number;

    constructor(private element: ElementRef, public renderer: Renderer, public util: Util) {


    }

    ngOnInit() {

        if (!this.util.nativeApp()) return;

        this.scrollContent = this.element.nativeElement.getElementsByClassName('scroll-content')[0];
        //this.scrollContent.style.transition = 'top 0.5s linear';
        //this.scrollContent.style.transition = 'margin-top 0.5s linear';

    }

    onScroll(event) {

        if (!this.util.nativeApp()) return;

        if (!this.header) {
            this.header = event.headerElement;
            this.headerHeight = this.header.clientHeight;
            this.header.style.transition = 'top 0.5s linear';
        }

        event.domWrite(() => {

            if (event.directionY === 'down' && event.scrollTop > 0) {
                this.renderer.setElementStyle(this.header, 'top', '-' + this.headerHeight + 'px');
                //this.renderer.setElementStyle(this.scrollContent, 'top', '-' + this.headerHeight + 'px');
                this.renderer.setElementStyle(this.scrollContent, 'margin-top', '0px');
                this.scrollTop = event.scrollTop;
            }

            if (event.directionY === 'up' && (event.scrollTop <= this.headerHeight+10 || event.scrollTop <= this.scrollTop - 90)) {
                this.renderer.setElementStyle(this.header, 'top', '0px');
                //this.renderer.setElementStyle(this.scrollContent, 'top', '0px');
                setTimeout(() => this.renderer.setElementStyle(this.scrollContent, 'margin-top', this.headerHeight + 'px'), 500);
            }

        });

        //console.log('---> ' + event.directionY + ' -----> ' + this.scrollContent.offsetTop);

    }

}



// WEBPACK FOOTER //
// ./src/directives/hide-header.ts